import React, { useState } from "react";
import "../styles/IntrebariFrecvente.css";

const IntrebariFrecvente = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      question: "Cum pot face o comanda de flori?",
      answer:
        "Puteți plasa o comandă direct pe site-ul nostru, selectând buchetul dorit, adăugându-l în coș și completând detaliile de livrare. De asemenea, ne puteți contacta telefonic sau prin WhatsApp pentru comenzi personalizate sau pentru solictari de livrare speciale.",
    },
    {
      question: "Ce forme de plată sunt acceptate?",
      answer:
        "Acceptăm plăți online prin card bancar (Visa, Mastercard), cash la ridicare de la sediu si cash la livrare.",
    },
    {
      question: "Este posibil de specificat o dată exactă de livrare?",
      answer:
        "Da, la finalizarea comenzii puteți selecta o dată exactă de livrare, iar noi ne asigurăm că buchetul ajunge la timp.",
    },
    {
      question: "Care este timpul de livrare a florilor în Chișinău?",
      answer:
        "Timpul de livrare este, în medie, între 2 și 4 ore de la confirmarea comenzii, în funcție de momentul plasarii comenzii, de disponibilitate și locație.",
    },
    {
      question: "În ce zone livrați?",
      answer:
        "Livrăm gratuit în toate sectoarele orasului Chișinău, de la 1200 lei. Pentru alte regiuni/raioane se percepe o taxa suplimentara indicata in formularul de comanda.",
    },
    {
      question: "În ce zone este livrarea gratuită?",
      answer:
        "Oferim livrare gratuită în raza orasului Chișinău pentru comenzile de peste 1200 lei, cu excepția zonelor limitrofe precum Durlești, Codru, Ialoveni, Singera și alte localități din apropiere.",
    },
    {
      question: "Care este ora limită pentru livrarea în aceeași zi?",
      answer:
        "Pentru livrarea în aceeași zi,in raza orasului comenzile trebuie plasate până la ora 16:00. Comenzile efectuate după această oră vor fi livrate în ziua următoare. Iar pentru pe teritoriul Republicii Moldova, comenzile trebuie plasate cu cel putin 24 de ore inainte.",
    },
    {
      question: "Care sunt termenii de livrare?",
      answer:
        "Livrăm florile în cel mai scurt timp posibil și în condiții optime. În cazul în care destinatarul nu este disponibil, încercăm să reprogramăm livrarea sau să lăsăm buchetul la o persoană de încredere.",
    },
    {
      question: "Lucrați în weekend?",
      answer:
        "Da, oferim livrări și în weekend, inclusiv în zile de sărbătoare, pentru a vă ajuta să creați momente speciale.",
    },
    {
      question: "Unde scriu informațiile despre destinatar?",
      answer:
        "Informațiile despre destinatar (nume, adresă, telefon) trebuie completate în formularul de comandă, la secțiunea Detalii de livrare.",
    },
    {
      question: "Pot face modificări după efectuarea comenzii?",
      answer:
        "Dacă doriți să modificați comanda (adresa, data livrării, mesajul atașat), vă rugăm să ne contactați cât mai curând posibil telefonic, sau pe Viber, WhatsApp, Telegram.  Modificările sunt posibile doar înainte ca buchetul să fie pregătit pentru livrare.",
    },
    {
      question: "Pot opta pentru anonimat în cadrul comenzilor de flori?",
      answer:
        "Da, dacă doriți ca livrarea să fie anonimă, specificați acest lucru în detaliile comenzii, iar noi nu vom divulga expeditorul.",
    },
    {
      question:
        "Se poate face relivrare la buchet de flori dacă nici destinatarul nici expeditorul nu a fost de găsit în ziua livrării?",
      answer:
        "Da, încercăm să reprogramăm livrarea. Dacă nici destinatarul, nici expeditorul nu răspund, florile pot fi ridicate de la sediul nostru sau livrate la o altă adresă, contra unei taxe suplimentare.",
    },
    {
      question:
        "Pot plasa o comandă de flori dacă nu am adresa de livrare, ci doar numărul de telefon al destinatarului?",
      answer:
        "Da, putem contacta telefonic destinatarul pentru a stabili detaliile de livrare, asigurând discreția și surpriza momentului.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="section intrebari-frecvente">
      <h1 className="heading-secondary">Întrebări frecvente</h1>
      <p className="subheading">
        Ai nevoie de ajutor? Aici ai putea gasi răspunsurile la unele din
        întrebările tale.
      </p>
      <div className="questions-container">
        {questions.map((item, index) => (
          <div
            key={index}
            className={`question-box ${activeIndex === index ? "visible" : ""}`}
          >
            <div className="question-header">
              <span className="question">{item.question}</span>
              <button
                className={`btn-caret ${activeIndex === index ? "active" : ""}`}
                onClick={() => toggleAnswer(index)}
              >
                <span
                  className={`caret-icon ${
                    activeIndex === index ? "rotated" : ""
                  }`}
                ></span>
              </button>
            </div>
            <div
              className={`answer ${activeIndex === index ? "visible" : ""}`}
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
              }}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IntrebariFrecvente;
